import React from "react";
interface ValueItem {
  icon: string;
  title: string;
  description: string;
}

interface ValuesSectionProps {
  eyebrow?: string;
  title?: string;
  values?: ValueItem[];
}

const defaultValues: ValueItem[] = [
  {
    icon: "⚖️",
    title: "Éthique",
    description: "Exercer avec honnêteté et responsabilité.",
  },
  {
    icon: "✨",
    title: "Qualité",
    description: "Des produits et prestations avec des standards rigoureux.",
  },
  {
    icon: "🎗️",
    title: "Confiance",
    description: "Une relation transparente et durable avec nos clients.",
  },
  {
    icon: "🙏",
    title: "Respect",
    description: "Respecter chaque personne, ses convictions et ses besoins.",
  },
  {
    icon: "🧴",
    title: "Hygiène & Sécurité",
    description:
      "Une attention particulière aux règles d'hygiène lors des prestations.",
  },
  {
    icon: "📚",
    title: "Tradition & Transmission",
    description:
      "Valoriser les savoirs traditionnels et les transmettre avec responsabilité.",
  },
];

const ValuesSection: React.FC<ValuesSectionProps> = ({
  eyebrow = "Ce qui nous guide",
  title = "Nos valeurs",
  values = defaultValues,
}) => {
  return (
    <section className="values-section py-5 py-lg-6">
      <div className="container-xl">
        <div className="text-center mb-5">
          <p className="values-eyebrow mb-3">{eyebrow}</p>
          <h2 className="values-title">{title}</h2>
        </div>

        <div className="row g-4">
          {values.map((value, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div className="value-card h-100 text-center p-4">
                <div className="value-icon mb-3">{value.icon}</div>
                <h3 className="value-title mb-2">{value.title}</h3>
                <p className="value-description mb-0">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;